module.exports = __webpack_public_path__ + "assets/media/lunch.50c1cbca.mp3";